import axios from "axios";
import config from "../../config";
import { CleaningDataModel } from "./types";

const apiUrl = config.api;

export const getCleaningData = async (): Promise<CleaningDataModel> => {
  const response = await axios.get<CleaningDataModel>(`${apiUrl}/cleaning/`);

  return response.data;
};

export default getCleaningData;
